import { useEffect, useState } from 'react';

interface TocItem {
  id: string;
  label: string;
}

export default function ArticleToc({ items }: { items: TocItem[] }) {
  const [active, setActive] = useState(items[0]?.id ?? '');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: '-120px 0px -65% 0px', threshold: 0 },
    );

    items.forEach((item) => {
      const el = document.getElementById(item.id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [items]);

  return (
    <nav aria-label="文章目录" className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h2 className="flex items-center gap-2 font-heading text-sm font-bold text-foreground-950">
        <i className="ri-list-unordered text-primary-600" aria-hidden="true"></i>
        本页目录
      </h2>
      <ul className="mt-4 space-y-1">
        {items.map((item, index) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              className={`flex items-start gap-2.5 rounded-md px-3 py-2 text-sm transition-colors ${
                active === item.id
                  ? 'bg-primary-100 text-primary-800'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              <span className="mt-0.5 text-xs text-foreground-400">{String(index + 1).padStart(2, '0')}</span>
              <span>{item.label}</span>
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}